export default {
      id: "block_nether_flat-usage",
      viewBox: "0 0 224.88 224.88",
      url: __webpack_public_path__ + "live-atlas/img/icons.e641665a.svg#block_nether_flat",
      toString: function () {
        return this.url;
      }
    }